<template>
    <div
        class="drop-zone"
        :class="{ 'is-dragover': isDragOver }"
        @dragenter.prevent="onDragEnter"
        @dragover.prevent="onDragOver"
        @dragleave.prevent="onDragLeave"
        @drop.prevent="onDrop"
        @click="pickFile"
    >
        <input
            ref="fileInput"
            type="file"
            class="file-input"
            accept=".pdf,image/*"
            @change="onFileSelect"
            hidden
        />
        <small>
            Glissez votre document ici,<br />
            ou <a href="#">parcourir</a>
        </small>
    </div>
</template>

<script>
export default {
    name: 'DocumentDropZone',
    data() {
        return {
            isDragOver: false,
            dragCounter: 0,
            files: []
        };
    },
    methods: {
        onDragEnter() {
            // First time in, turn on the highlight:
            if (!this.dragCounter++) {
                this.isDragOver = true;
            }
        },
        onDragLeave(e) {
            // Decrement counter; if we’ve completely left the zone, turn off
            this.dragCounter--;
            // If the new drop-zone element *doesn’t* contain the thing we’re entering,
            // we really left:
            if (!this.$el.contains(e.relatedTarget)) {
                this.isDragOver = false;
                this.dragCounter = 0;
            }
        },
        onDragOver(e) {
            /* preventDefault so drop will fire */
            e.preventDefault();
        },
        onDrop(e) {
            this.isDragOver = false;
            this.dragCounter = 0;
            const dropped = Array.from(e.dataTransfer.files).filter(f => this.isValidType(f));
            if (dropped.length > 0) {
                this.addFiles(dropped);
            }
        },
        pickFile() {
            this.$refs.fileInput.click();
        },
        onFileSelect(e) {
            const documents = Array.from(e.target.files).filter(f => this.isValidType(f));
            if (documents.length > 0) {
                this.addFiles(documents);
            }
            e.target.value = null;
        },
        isValidType(file) {
            if (file.type === 'application/pdf' || file.type.startsWith('image/')) {
                return true;
            }
            this.$notify({
                title: 'Attention',
                text: 'Seuls les PDF et les images sont autorisés.',
                type: 'warn'
            });
            return false;
        },
        addFiles(newFiles) {
            this.files = [newFiles[0]];
            this.$emit('update:file', this.files[0]);
        },
        humanSize(bytes) {
            const kb = bytes / 1024;
            return kb < 1024 ? `${Math.round(kb)} KB` : `${(kb / 1024).toFixed(1)} MB`;
        }
    }
};
</script>

<style scoped>
.drop-zone {
    border: 2px dashed #aaa;
    border-radius: 6px;
    padding: 2rem;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.2s, border-color 0.2s;
}
.drop-zone.is-dragover {
    background-color: #f0f8ff;
    border-color: #3399ff;
}
.drop-zone p {
    margin: 0;
    font-size: 1rem;
}
.file-list {
    margin-top: 1rem;
    list-style: none;
    padding: 0;
    text-align: left;
}
.file-list li {
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
}
</style>
